import { Injectable } from "@angular/core";
import { UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "../auth/auth.service";
import { take, tap } from "rxjs/operators";
import { UnauthorizePromptService } from "../auth/unauthorize-prompt/unauthorize-prompt.service";
import { UserClaimsService } from "../user-claims.service";

@Injectable({
  providedIn: "root",
})
export class UserTypeGuard  {
  constructor(
    private authService: AuthService,
    private notAuth: UnauthorizePromptService,
    public userClaims: UserClaimsService
  ) {}

  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.userClaims.isPatient$.pipe(
      take(1),
      tap((isPatient) => (!isPatient ? this.notAuth.showPopup() : undefined))
    );
  }
}
